import { WarningIcon } from "@phosphor-icons/react/dist/csr/Warning";
import { useNavigate } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface PayoutNoticesProps {
  businessId: string | null | undefined;
  showNotClosedWarning: boolean;
  showInsufficientFunds: boolean;
  isAccountSummaryLoading: boolean;
}

export const PayoutNotices = ({
  businessId,
  showNotClosedWarning,
  showInsufficientFunds,
  isAccountSummaryLoading,
}: PayoutNoticesProps) => {
  const navigate = useNavigate();

  return (
    <>
      {showNotClosedWarning && (
        <Stack direction="row" align="center" className="pb-6" gap={2}>
          <WarningIcon className="h-5 w-5 shrink-0 text-warning" />
          <Text>
            Heads up, you're about to pay a referral bonus for a referral that
            hasn't closed yet.{" "}
          </Text>
        </Stack>
      )}

      {showInsufficientFunds && (
        <Stack direction="row" align="center" className="pb-6" gap={2}>
          <WarningIcon className="h-5 w-5 shrink-0 text-danger" />
          <Text>
            You don't have sufficient funds for this payout.{" "}
            <Button
              type="button"
              variant="link"
              className="h-auto p-0"
              onClick={() =>
                navigate(`/business-settings/${businessId}/payments`)
              }
            >
              Would you like to add funds?
            </Button>
          </Text>
        </Stack>
      )}

      {isAccountSummaryLoading && (
        <Stack
          role="status"
          direction="row"
          align="center"
          className="pb-6"
          gap={2}
        >
          <Spinner aria-hidden size={16} className="text-subtle" />
          <Text>Loading account balance…</Text>
        </Stack>
      )}
    </>
  );
};
